import Todo from '../store/schema/Todo';
import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';
import { OwaDate } from 'owa-datetime';
import { Datapoints } from '../datapoints';

export const markTodoComplete = action('markTodoComplete', (todoId: string) =>
    addDatapointConfig(Datapoints.todoItemActionMarkComplete(), {
        todoId,
    })
);

export const markTodoIncomplete = action('markTodoIncomplete', (todoId: string) =>
    addDatapointConfig(Datapoints.todoItemActionMarkIncomplete(), {
        todoId,
    })
);

export const star = action('clickUnfilledTodoStar', (todoId: string) =>
    addDatapointConfig(Datapoints.todoItemActionStar, {
        todoId,
    })
);

export const unstar = action('clickFilledTodoStar', (todoId: string) =>
    addDatapointConfig(Datapoints.todoItemActionUnstar, {
        todoId,
    })
);

export const updateOrder = action('updateOrder', (itemId: string, order: OwaDate) => ({
    itemId,
    order,
}));

export const updateTodoSubject = action('updateTodoSubject', (itemId: string, subject: string) =>
    addDatapointConfig(Datapoints.todoItemActionUpdateSubject, {
        itemId,
        subject,
    })
);

export const updateTodo = action('updateTodo', (itemId: string, todoUpdates: Partial<Todo>) => ({
    itemId,
    todoUpdates,
}));

export const todoUpdated = action(
    'todoUpdated',
    (isSuccessful: boolean, itemId: string, todoUpdates: Partial<Todo>) => ({
        isSuccessful,
        itemId,
        todoUpdates,
    })
);

export const deleteTodo = action('deleteTodo', (itemId: string) =>
    addDatapointConfig(Datapoints.todoItemActionContextMenuDelete(), {
        itemId,
    })
);

export const updateTodoReminder = action(
    'updateTodoReminder',
    (itemId: string, reminderDateTime?: OwaDate) =>
        addDatapointConfig(Datapoints.todoItemActionReminderEdited, {
            itemId,
            reminderDateTime,
        })
);

export const updateTodoDueDate = action('updateTodoDueDate', (itemId: string, dueDate?: OwaDate) =>
    addDatapointConfig(Datapoints.todoItemActionDueDateEdited, {
        itemId,
        dueDate,
    })
);

export const clickEmail = action('clickTodoLinkedEmail', (emailId: string) =>
    addDatapointConfig(Datapoints.todoItemActionViewEmail(), {
        emailId: emailId,
    })
);
